import axios from "axios";
import { useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Spinner,
} from "react-bootstrap";
import { useCreateUserWithEmailAndPassword, useUpdateProfile } from "react-firebase-hooks/auth";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { auth } from "../../../../firebase.init";
import signupImg from "../../../../img/Signup.gif";
import SocialLogin from "../SocialLogin";

function Singup() {
  // after login navigate
  const location = useLocation();
  const navigate = useNavigate();
  let from = location.state?.from?.pathname || "/";

  const [createUserWithEmailAndPassword, user, loading, error] =
    useCreateUserWithEmailAndPassword(auth, { sendEmailVerification: true });
  const [updateProfile, updating, updateError] = useUpdateProfile(auth);
  const [validated, setValidated] = useState(false);
  const [pass, setPass] = useState("");
  const [rePass, setRePass] = useState("");

  const checkPass = (event) => {
    if (event.target.name === "pass") {
      setPass(event.target.value);
    }
    if (event.target.name === "rePass") {
      setRePass(event.target.value);
    }
  };
  const handleSubmit = async(event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    const url = "https://rocky-ravine-79485.herokuapp.com/users";
    if (form.checkValidity() && pass === rePass) {
      const fName = event.target.fName.value;
      const lName = event.target.lName.value;
      const email = event.target.email.value;
      const pass = event.target.pass.value;
      const photoUrl = event.target.photoUrl.value;
      const city = event.target.city.value;
      const state = event.target.state.value;
      const zip = event.target.zip.value;
      let createUser = {
        fName,
        lName,
        email,
        pass,
        photoUrl,
        city,
        state,
        zip,
      };
      createUserWithEmailAndPassword(email, pass);
     await axios.post(url, createUser).then(
        (response) => {
          console.log(response);
        },
        (error) => {
          console.log(error);
        }
      );
      const {data}=await axios.post('https://rocky-ravine-79485.herokuapp.com/login',{email})
   localStorage.setItem("token",data.accessToken)
      await updateProfile({ displayName:fName, photoURL:photoUrl });
   
      setValidated(true); 
    }
   
  };
  if(updating){
    console.log("updating");
  }
  if(updateError){
    console.log(updateError);
  }
  if (user) {
    navigate(from, { replace: true });
  
    document.getElementById("signUpForm").reset();
  }

  return (
    <Container>
      <Row className="my-5">
        <Col>
          <Form
            id="signUpForm"
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Form.Group
                as={Col}
                md="6"
                className="mt-3"
                controlid="validationCustom02"
              >
                <Form.Label>First name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="fName"
                  placeholder="First name"
                  defaultValue=""
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="6"
                className="mt-3"
                controlid="validationCustom02"
              >
                <Form.Label>Last name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="lName"
                  placeholder="Last name"
                  defaultValue=""
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              </Form.Group>
              {/* Email */}
              <Form.Group
                as={Col}
                md="12"
                className="my-3"
                controlid="validationCustom02"
              >
                <Form.Label>Email</Form.Label>
                <Form.Control
                  required
                  name="email"
                  type="email"
                  placeholder="mail@domain.com"
                  defaultValue=""
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              </Form.Group>
              {/* password */}
              <Form.Group
                as={Col}
                md="12"
                className="my-3"
                controlid="validationCustom02"
              >
                <Form.Label>Password</Form.Label>
                <Form.Control
                  required
                  onBlur={checkPass}
                  name="pass"
                  type="password"
                  placeholder="**********"
                  defaultValue=""
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="12"
                className="mt-3"
                controlid="validationCustom02"
              >
                <Form.Label>Re-type Password</Form.Label>
                <Form.Control
                  onBlur={checkPass}
                  required
                  type="Password"
                  name="rePass"
                  placeholder="**********"
                  defaultValue=""
                />
                {pass === rePass ? (
                  <span className="text-success mt-2 d-block">
                    Password Match
                  </span>
                ) : (
                  <span className="text-danger mt-2 d-block">
                    Password did't Match
                  </span>
                )}
              </Form.Group>
              <Form.Group
                as={Col}
                md="12"
                className="mt-3"
                controlid="validationCustomUsername"
              >
                <Form.Label>Photo Url</Form.Label>
                <InputGroup hasValidation>
                  <InputGroup.Text id="inputGroupPrepend">
                    <svg
                      style={{ width: "15px" }}
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Input your photo Url"
                    name="photoUrl"
                    aria-describedby="inputGroupPrepend"
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Input A valid Url
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlid="validationCustom03">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="City"
                  name="city"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid city.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="3" controlid="validationCustom04">
                <Form.Label>State</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="State"
                  name="state"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid state.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="3" controlid="validationCustom05">
                <Form.Label>Zip</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Zip"
                  name="zip"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid zip.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Form.Group className="mb-3">
              <Form.Check
                required
                label="Agree to terms and conditions"
                feedback="You must agree before submitting."
                feedbackType="invalid"
              />
            </Form.Group>
            <Button type="submit" variant="success">
              Sign Up
            </Button>
          </Form>
          {loading ? <Spinner animation="border" variant="success" /> : ""}
          {error ? error.message : ""}
          <br />
          <hr />
          {<SocialLogin />}
          <br />
          <p>
            Already have A account{" "}
            <Link to="/login">
              Login{" "}
              <svg
                width={15}
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </Link>
          </p>
        </Col>
        <Col>
          <img
            style={{ width: "100%", objectFit: "cover" }}
            src={signupImg}
            alt=""
          />
        </Col>
      </Row>
    </Container>
  );
}

export default Singup;
